module.exports = __webpack_public_path__ + "24d1a884844a0c5bc243a2e6615f8e44.jpg";